import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'
const SelfService: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component={'svg'}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 48 48"
    {...props}
  >
    <g id="Layer_1_00000015344787105717017330000016463892523582779070_">
      <path
        d="M34.36 26.88c0-.96-.78-1.75-1.75-1.75-.96 0-1.75.78-1.75 1.75v-1.75c0-.96-.78-1.75-1.75-1.75-.96 0-1.75.78-1.75 1.75v-.87c0-.96-.78-1.75-1.75-1.75-.96 0-1.75.78-1.75 1.75v-6.99c0-.96-.78-1.75-1.75-1.75-.96 0-1.75.78-1.75 1.75v12.25l-1.99-4.39c-.39-.88-1.43-1.28-2.31-.88-.88.39-1.28 1.43-.88 2.31l4.64 10.22c.62 3.39 3.58 5.97 7.15 5.97 2.64 0 4.94-1.41 6.22-3.51a6.263 6.263 0 0 0 1.16-3.61l.01-8.75z"
        style={{
          fill: '#002677',
        }}
      />
      <path
        d="M22.24 11.86c-.67 0-1.21-.54-1.21-1.21V6.47c0-.67.54-1.21 1.21-1.21.67 0 1.21.54 1.21 1.21v4.18c0 .67-.54 1.21-1.21 1.21zM25.4 13.99c-.41-.52-.32-1.29.2-1.7l3.29-2.59c.52-.41 1.29-.32 1.7.2.41.52.32 1.29-.2 1.7l-3.29 2.59c-.52.41-1.29.32-1.7-.2zM19.08 13.99c.41-.52.32-1.29-.2-1.7L15.59 9.7c-.52-.41-1.29-.32-1.7.2-.41.52-.32 1.29.2 1.7l3.29 2.59c.52.41 1.29.32 1.7-.2z"
        style={{
          fill: '#ff612b',
        }}
      />
    </g>
  </Box>
)
export default SelfService
